module.exports = function () {
    const buttons = jQuery('.ExpandDocuments'),
        expanders = jQuery('.DocumentsExpander');

    expanders.slideUp(0);
    expanders.removeClass('invisible h-0');
    buttons.on("click", function () {
        jQuery(this).prev(".DocumentsExpander").slideDown(400);
        jQuery(this).fadeOut(100);
    });
}